/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 20.12.12, 18:01
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { GGSTextFieldSignal } from "./GGSTextFieldSignal";
import {KeyboardEvent} from "@goodgamestudios/createjs-utilities";


export class KeyUpSignal extends GGSTextFieldSignal {
    constructor() {
        super();
        this.mappedEventType = KeyboardEvent.KEY_UP;
    }

    public dispatchTyped(event: KeyboardEvent): void {
        super.dispatch(event);
    }
}
